import { UploadedFile } from 'src/data-capture/hooks/file-uploads/types';

/**
 * Ancestor-folder path of a file, e.g. "Pensions / Providers" ('' at the top level).
 * The `seen` set keeps a broken or cyclic `parentId` chain from looping forever.
 */
export const buildFolderPath = (file: UploadedFile, allFiles: UploadedFile[]): string => {
  const byId = new Map(allFiles.map(f => [f.id, f]));
  const segments: string[] = [];
  const seen = new Set<string>([file.id]);

  let currentParentId = file.parentId;
  while (currentParentId && !seen.has(currentParentId)) {
    seen.add(currentParentId);
    const parent = byId.get(currentParentId);
    if (!parent) {
      break;
    }
    segments.unshift(parent.file.fileName);
    currentParentId = parent.parentId;
  }

  return segments.join(' / ');
};
